/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateTransferACHAddendaRecord,
  CreateTransferACHAddendaRecord$inboundSchema,
  CreateTransferACHAddendaRecord$Outbound,
  CreateTransferACHAddendaRecord$outboundSchema,
} from "./createtransferachaddendarecord.js";

export type CreateTransferDestinationACH = {
  /**
   * An optional override of the default NACHA company entry description for a transfer.
   */
  companyEntryDescription?: string | undefined;
  /**
   * An optional override of the default NACHA company name for a transfer.
   */
  originatingCompanyName?: string | undefined;
  addenda?: Array<CreateTransferACHAddendaRecord> | undefined;
};

/** @internal */
export const CreateTransferDestinationACH$inboundSchema: z.ZodType<
  CreateTransferDestinationACH,
  z.ZodTypeDef,
  unknown
> = z.object({
  companyEntryDescription: z.string().optional(),
  originatingCompanyName: z.string().optional(),
  addenda: z.array(CreateTransferACHAddendaRecord$inboundSchema).optional(),
});
/** @internal */
export type CreateTransferDestinationACH$Outbound = {
  companyEntryDescription?: string | undefined;
  originatingCompanyName?: string | undefined;
  addenda?: Array<CreateTransferACHAddendaRecord$Outbound> | undefined;
};

/** @internal */
export const CreateTransferDestinationACH$outboundSchema: z.ZodType<
  CreateTransferDestinationACH$Outbound,
  z.ZodTypeDef,
  CreateTransferDestinationACH
> = z.object({
  companyEntryDescription: z.string().optional(),
  originatingCompanyName: z.string().optional(),
  addenda: z.array(CreateTransferACHAddendaRecord$outboundSchema).optional(),
});

export function createTransferDestinationACHToJSON(
  createTransferDestinationACH: CreateTransferDestinationACH,
): string {
  return JSON.stringify(
    CreateTransferDestinationACH$outboundSchema.parse(
      createTransferDestinationACH,
    ),
  );
}
export function createTransferDestinationACHFromJSON(
  jsonString: string,
): SafeParseResult<CreateTransferDestinationACH, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateTransferDestinationACH$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateTransferDestinationACH' from JSON`,
  );
}
